<template>
    <div class="level">
        <span
            class="label"
            v-if="label"
        >{{ label }}</span>
        <div class="value">
            <div class="scale">
                <div
                    class="scale-item"
                    v-for="i in requiredLevelValue"
                    :class="getClass(i)"
                    :key="i"
                ></div>
            </div>
            <div
                class="name"
                :class="nameClass"
            >{{ levelName }}</div>
        </div>
    </div>
</template>

<script>
import {getCompetenceLevel} from '@/tools/education';

export default {
    props: {
        label: {
            type: String,
            required: false,
        },
        currentLevel: {
            type: String,
            default: null,
        },
        requiredLevel: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        nameClass: {
            type: String,
            default: '',
        },
    },
    computed: {
        levelName() {
            return getCompetenceLevel(this.currentLevel).name;
        },
        currentLevelValue() {
            return getCompetenceLevel(this.currentLevel).value;
        },
        requiredLevelValue() {
            return getCompetenceLevel(this.requiredLevel).value;
        },
        maxLevelValue() {
            return getCompetenceLevel('advanced').value;
        },
    },
    methods: {
        getClass(i) {
            if (i <= this.currentLevelValue) {
                return [`scale-item--${this.type}`];
            } else if (i <= this.requiredLevelValue) {
                return [`scale-item--required`];
            } else {
                return [];
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '../../../../../styles/rem';
    @import '../../../../../styles/mrem';

    .label {
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: rem(16);
        line-height: rem(24);
        color: #2A2626;
        margin-bottom: rem(8);
        display: inline-block;

        @include on-mobile {
            font-size: mrem(16);
            line-height: mrem(24);
            margin-bottom: mrem(8);
        }
    }

    .value {
        display: flex;
        align-items: center;

        .scale {
            display: flex;
            align-items: flex-start;
            margin-right: rem(4);

            @include on-mobile {
                margin-right: mrem(4);
            }

            &-item {
                width: 6px;
                height: rem(18);
                background: rgba(0, 0, 0, 0);
                border-radius: rem(4);
                margin-right: 4px;

                @include on-mobile {
                    height: mrem(18);
                    border-radius: mrem(4);
                }

                &--required {
                    background: #CEDBEE;
                }

                &--soft {
                    background: #8D7BFB;
                }

                &--hard {
                    background: #1AB2D3;
                }

                &--expert {
                    background: #68C87A;
                }
            }
        }

        .name {
            font-family: 'Proxima Nova', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: rem(15);
            line-height: rem(22);
            color: #2A2626;

            &.bold {
                font-weight: 600;
                font-size: rem(16);
                line-height: rem(24);

                @include on-mobile {
                    font-size: mrem(16);
                    line-height: mrem(24);
                }
            }

            &.hidden {
                display: none;
            }

            @include on-mobile {
                font-size: mrem(16);
                line-height: mrem(24);
            }
        }
    }
</style>